import { Component, OnInit } from '@angular/core';
import { Firestore, collection, query, where, orderBy, limit, collectionData, addDoc, CollectionReference } from '@angular/fire/firestore';
import { Session } from '../../_models/result';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { AsyncPipe, JsonPipe, DecimalPipe, DatePipe, KeyValuePipe } from '@angular/common';
import { MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent } from '@angular/material/card';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatButton } from '@angular/material/button';
import { MatTabGroup, MatTab } from '@angular/material/tabs';


@Component({
  selector: 'app-sessions',
  templateUrl: './sessions.component.html',
  styleUrls: ['./sessions.component.css'],
  imports: [MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent, MatFormField, MatLabel, MatSelect, MatOption, MatButton, MatTabGroup, MatTab, AsyncPipe, JsonPipe, DecimalPipe, DatePipe, KeyValuePipe]
})
export class SessionsComponent implements OnInit {

  constructor(
    private firestore: Firestore,
    private route: ActivatedRoute,
    private auth: AuthService,
  ) { }

  schoolId = '';
  sessions?: Observable<Session[]>;
  selected: Session | undefined = undefined;

  ngOnInit() {
    this.schoolId = this.route.snapshot.parent?.paramMap.get('schoolId') ?? '';
    this.loadSessions(this.schoolId);
  }

  private loadSessions(schoolId: string) {
    const sessionCol = collection(this.firestore, 'sessions') as CollectionReference<Session>;
    const q = query(sessionCol,
      where('univName', '==', schoolId),
      orderBy('savedAt', 'desc'),
      limit(20)
    );
    this.sessions = collectionData(q, { idField: 'id' }) as Observable<Session[]>;
  }

  isNumber(value: unknown): boolean {
    return value != null && !isNaN(Number(String(value)));
  }

  toPlainObject(value: object): Record<string, unknown> {
    return { ...value };
  }

  public async createAdminSession() {
    if (this.selected) {
      const user = await this.auth.currentUser();

      const adminSession = {
        answers: this.selected.answers,
        cbUserId: this.selected.cbUserId,
        savedAt: this.selected.savedAt,
        univName: this.selected.univName,
        userId: user?.uid ?? '',
        // Newer sessions use answers[].hidden instead of preparedAnswers.
        // Omit the legacy field when absent so Firestore does not receive `undefined`.
        ...(this.selected.preparedAnswers !== undefined ? { preparedAnswers: this.selected.preparedAnswers } : {})
      };

      const sessionsAdminCol = collection(this.firestore, 'sessions_admin');
      await addDoc(sessionsAdminCol, adminSession);
    }
  }

}
